import React from 'react';

const SvgStep5 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 62 62" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M31 59c6.14 0 11.817-1.976 16.432-5.326C54.442 48.585 59 40.324 59 31c0-3-.472-5.89-1.346-8.6C54.025 11.143 43.464 3 31 3 18.533 3 7.968 11.148 4.342 22.41A27.981 27.981 0 003 31c0 9.294 4.528 17.53 11.5 22.624A27.874 27.874 0 0031 59z"
      stroke="#FFC543"
      strokeWidth={6}
      fill="none"
    />
  </svg>
);

export default SvgStep5;
